<div class="page-padding">

    <div class="panel__header">
      <span class="panel__header__title">Observation Point Setup</span>
    </div>
  
    <div style="margin-left: 39%;" *ngIf="loading">
      <mat-spinner> </mat-spinner>
    </div>
    <div class="step-container">
  
      <div class="margin-bottom-24">
        1. Select Schematic to add observation points <i>(Click on thumbnail)</i>
      </div>
  
      <div class="margin-bottom-24" style="white-space: nowrap; display: flex; gap: 6px; width: 100%;">
        <ng-container *ngFor="let sch of schematicList">
          <div class="implement-image-container2">
            <div class="image-sch-container">
              <div class="div-hide-schematic">
                <mat-icon *ngIf="sch.OBSCount == sch.InactiveOBSCount" class="hide-schematic" [ngClass]="sch.IsHidden ? 'gray-icon' : 'red-icon'"
                          [title]="sch.IsHidden ? 'Click to unhide schematic' : 'Click to hide schematic'" (click)="openHideConfirmationBox(sch.Id, sch.ImageName, sch.IsHidden)">visibility_off</mat-icon>

              </div>
              <img (click)="!sch.IsHidden && openSchematicAndObservationPointDetailsWindow(sch)" [title]="!sch.IsHidden
                              ? 'Click the image to add observation points or cracks'
                              : 'Schematic is hidden and not available to add observation points or cracks'" [src]="getImage(sch.Data)" style="width: 100%; height: 100%;" />
            </div>
            <div style="display: flex;">
              <div style="margin-top: 5px;">
                <span style="font-size: small; white-space: nowrap;">{{sch.ImageName}}</span>
              </div>
              <div *ngIf="sch.OBSCount == 0 && sch.InactiveOBSCount == 0">
                <span style=" white-space: nowrap;"><i matTooltip="Click to permanently delete the schematic" class="material-icons sc-icon" (click)="deleteimage(sch.Id,false,sch.OBSCount)">delete</i></span>
              </div>
              <div>
                <span class="material-icons" (click)="fileInput.click()" title="Edit Schematic Image">edit</span>
                <input style="display: none;" type="file"
                       #fileInput
                       (change)="onSelectPhoto($event, sch.Id)">
              </div>
              <div *ngIf="sch.OBSCount == 0 && sch.InactiveOBSCount == 0">
                <span style=" white-space: nowrap; "><i class="material-icons sc-icon" style="visibility: hidden;">delete</i></span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
  
      <div oncontextmenu="return false;">
        <div style="margin-top: 5px;">
          <div class="question__text">
            2. Add Observation Points (OP) to each Component <i>
              (clicking on
              image where observation point is required)(enter multiple OP for each component as
              required)
            </i>
          </div>
          <div class="search-container">
            <div>
              <input class="no-grow newCompInput_Select" (keyup)="onObservationNameFilterChange()"
                     type="text" placeholder="Filter list" [(ngModel)]="observationListFilter" />
            </div>
            <div>
              <mat-checkbox id="cbHideSelectedOPs" (checked)="hideSelectedOPs"
                            (click)="toggleSelectedOPs()" color="primary">Hide Selected</mat-checkbox>
            </div>
            <div>
              <mat-checkbox id="cbHideUnselectedOPs" (checked)="hideUnselectedOPs"
                            (click)="toggleUnselectedOPs()" color="primary">Hide Unselected</mat-checkbox>
            </div>
          </div>
        </div>
  
        <div>
          <table class="table relative" style="display: block;">
            <thead style="height: 60px;">
              <!-- <tr> -->
  
            <td style="padding: 0px 3px;">
              <mat-checkbox color="primary" [(ngModel)]="cbAllObservationSelect"
                            (click)="toggleAllObsevations(!cbAllObservationSelect)"
                            style=" margin-right: 16px!important;"></mat-checkbox>Component Type
            </td>
            <td> Component</td>
            <td>Obs. Point</td>
            <td>Obs. Question</td>
            <td>Obs. Type</td>
            <td>Obs. List</td>
            <td>Severity List</td>
            <td># of Readings Req.</td>
            <td>New Limit</td>
            <td>Used Limit</td>
            <td>Limit Range</td>
            <td>Measurement</td>
            <td>X Coord.</td>
            <td>Y Coord.</td>
            <td>End X Coord.</td>
            <td>End Y Coord.</td>
            <td>Question Instructions & Images</td>
            <!-- <td>Image</td> -->
            <td>Need Answer</td>
            <td>Need Image</td>
            <!-- <td>Make</td> -->
            <!-- <td style="padding: 5px 20px;">Part No.</td> -->
            <td>Inspection Type</td>
            <td>InActive/ Active</td>
            <td>Delete</td>
            <td>Edit</td>
            <td></td>
            <td></td>
            <!-- </tr> -->
            </thead>
  
     <!-- [class.tr-hover]="OP.Id == mouseoverOPId" -->
  
            <tbody>
              <ng-container *ngFor="let OP of observationListFiltered">
                <tr (mouseover)="onMouseOverOP(OP.Id)" (mouseout)="onMouseOutOP(OP.Id)" 
                 
                    *ngIf="selectionLogicForOPs(OP.Selected)">
                  <td title="{{OP.ComponentType}}">
                    <mat-checkbox style="margin-left: 2px;" [checked]="OP.Selected"
                                  [value]="OP.Id" color="primary"
                                  (change)="onObservationListControlChanged(OP.Id, OP.Name)">
                      {{OP.ComponentType}}
                    </mat-checkbox>
                  </td>
                  <!-- <td style="padding: 10px;" title="{{OP.ComponentName}}">{{OP.ComponentName}}</td> -->
                   <td>
                      <mat-form-field>
                      <mat-select  style="min-width: 110px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.ComponentId" ngDefaultControl required (selectionChange)="onComponentChange($event, OP.Id)">
                        <mat-option value="" disabled selected>Select Component</mat-option>
                        <mat-option *ngFor="let component of getFilteredComponents(OP.ComponentTypeId)" [value]="component.ComponentId">{{component.Name}}</mat-option>
                      </mat-select>
                      </mat-form-field>
                   </td>
                 
                  <td [class.cell-to-update]="highlightName(OP.Name)"  title="{{OP.Name}}">
                    <input id="OPName" placeholder="Name" type="text" [(ngModel)]="OP.Name"
                           class="length-input newCompInput_Select"
                           (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointName')"
                           required (focusout)="checkExistingOP(OP.Name)">
                  </td>
  
                  <td [class.cell-to-update]="highlightQName(OP.QName)"  title="{{OP.QName}}">
                    <input id="OPQName" placeholder="No Question" type="text" style="min-width: 200px !important;"
                           [(ngModel)]="OP.QName" class="length-input newCompInput_Select"
                           (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointQName')"
                           (focusout)="checkExistingOP(OP.Name)">
                  </td>
                  <td [class.cell-to-update]="highlightType(OP.ObservationPointType)" >
                    <select id="OPType" placeholder="Normal/Crack/Evaluation"
                            [(ngModel)]="OP.ObservationPointType" ngDefaultControl required
                            class="length-input"
                            style="height: 40px;
                              display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                            (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointType')"
                            required>
                      <option value="0"></option>
                      <option [value]="opt.Id" *ngFor="let opt of observationPointTypes">
                        {{opt.Name}}
                      </option>
                    </select>
                  </td>
                  <td [class.cell-to-update]="highlightObservationList(OP.ObservationListId) == 2">
                    <mat-form-field style="width: 110px">
                      <mat-select id="Ob_List" class="length-input3"
                                  style="min-width: 110px; height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                  placeholder="Select Obs. List"
                                  [(ngModel)]="OP.ObservationListId" ngDefaultControl >
                                  <!--(contextmenu)="displayContextMenu($event, OP.ObservationListId, OP.Id, 'ObservationList')"-->
                                  
                        <ng-container *ngIf="OP.ObservationPointType != 2">
                          <mat-option value="0"></mat-option>
                          <mat-option *ngFor="let obs of observationLists" [value]="obs.Id">
                            {{ obs.Name }}
                          </mat-option>
                        </ng-container>

                        <ng-container *ngIf="OP.ObservationPointType == 2">
                          <mat-option value="0"></mat-option>
                          <mat-option *ngFor="let obs of observationListForCrackObs" [value]="obs.Id">
                            {{ obs.Name }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </td>

                  <td  [class.cell-to-update]="highlightObservationList(OP.CrackSeverityListId) == 2"> 
                    <mat-form-field style="width: 110px" *ngIf="OP.ObservationPointType == 2">
                      <mat-select id="Ob_List" class="length-input3"
                                  style="min-width: 110px; height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                  placeholder="Select Severity List"
                                  [(ngModel)]="OP.CrackSeverityListId" ngDefaultControl >
                                  <!--(contextmenu)="displayContextMenu($event, OP.ObservationListId, OP.Id, 'ObservationList')"-->
                        <ng-container >
                          <mat-option value="0"></mat-option>
                          <mat-option *ngFor="let obs of observationListsForCrack" [value]="obs.Id">
                            {{ obs.Name }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td [class.cell-to-update]="highlightNumberOfReadings(OP.NumberOfReadings)" title="{{OP.NumberOfReadings}}"
                      class="length-input2 ">
                    <input id="NumberOfReadings" type="number" [(ngModel)]="OP.NumberOfReadings"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           (focusout)="onNumReadingsEntered(OP, $event)" class="length-input2 "
                           min="0" max="5" step="1"
                           (contextmenu)="displayContextMenu($event, false, OP.NumberOfReadings, 'NumberOfReadings')"
                           (keypress)="ValidateNumberInputs($event)">
                  </td>
  
  
  
                  <ng-container *ngIf="OP.LimitNew==0 && OP.LimitScrap==0">
                    <td [class.cell-to-update]="highlightLimitNew(OP.LimitNew, OP.LimitScrap) == 2">
                      <input id="LimitNew" placeholder="New Limit" type="number"   title="{{OP.LimitNew}}"
                             style=" height: 40px;
                              display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                             [(ngModel)]="OP.LimitNew" class="length-input2" step="0.1" min="0"
                             (focusout)="onLimitsEntered(OP, $event)"
                             (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitNew')"
                             (keypress)="ValidateNumberInputs($event)">
                    </td>
                    <td [class.cell-to-update]="highlightLimitScrap(OP.LimitNew, OP.LimitScrap) == 2" title="{{OP.LimitScrap}}">
                      <input id="LimitScrap" placeholder="Used Limit" type="number"
                             style="height: 40px;
                              display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                             [(ngModel)]="OP.LimitScrap" class="length-input2" step="0.1" min="0"
                             (focusout)="onLimitsEntered(OP, $event)"
                             (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitScrap')"
                             (keypress)="ValidateNumberInputs($event)">
                    </td>
                  </ng-container>
  
  
  
  
                  <ng-container *ngIf="OP.LimitNew!=0 || OP.LimitScrap!=0">
                    <td [class.cell-to-update]="highlightLimitNew(OP.LimitNew, OP.LimitScrap) == 2" title="{{OP.LimitNew}}">
                      <input id="LimitNew" placeholder="New Limit" type="number"
                             style=" height: 40px;
                              display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                             [(ngModel)]="OP.LimitNew" class="length-input2" step="0.1" min="0"
                             (focusout)="onLimitsEntered(OP, $event)"
                             (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitNew')"
                             (keypress)="ValidateNumberInputs($event)">
                    </td>
                    <td [class.cell-to-update]="highlightLimitScrap(OP.LimitNew, OP.LimitScrap) == 2"  title="{{OP.LimitScrap}}">
                      <input id="LimitScrap" placeholder="Used Limit" type="number"
                             style=" height: 40px;
                              display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                             [(ngModel)]="OP.LimitScrap" class="length-input2" step="0.1" min="0"
                             (focusout)="onLimitsEntered(OP, $event)"
                             (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitScrap')"
                             (keypress)="ValidateNumberInputs($event)">
                    </td>
                  </ng-container>
  
  
  
                  <td [class.cell-to-update]="highlightLimitRange(OP.LimitRange)"  title="{{OP.LimitRange}}">
                    <input id="LimitRange" placeholder="Limit Range" type="number"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.LimitRange" class="length-input2" step="0.1" min="0">
                  </td>
  
                  <td [class.cell-to-update]="highlightMeasurement(OP.Measurement)" title="{{OP.Measurement}}">
                    <input id="Measurement" placeholder="Measurement" type="number"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.Measurement" class="length-input2" step="0.1" min="0">
                  </td>
                  <td title="{{OP.Xcoord}}">
                    <input id="Xcoord" placeholder="X Coord" type="number"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.Xcoord" class="length-input2">
                  </td>
  
                  <td  title="{{OP.Ycoord}}">
                    <input id="Ycoord" placeholder="Y Coord" type="number"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.Ycoord" class="length-input2">
                  </td>
  
                  <td  title="{{OP.EndXcoord}}">
                    <input *ngIf="OP.ObservationPointType=='Crack'" id="EndXcoord" placeholder="End X Coord" type="number"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.EndXcoord" class="length-input2">
                  </td>
  
                  <td title="{{OP.EndYcoord}}">
                    <input *ngIf="OP.ObservationPointType=='Crack'" id="EndYcoord" placeholder="End Y Coord" type="number"
                           style=" height: 40px;
                          display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                           [(ngModel)]="OP.EndYcoord" class="length-input2">
                  </td>
                  <!-- Your Table Cell -->
                   <!-- <td [class.cell-to-update]="highlightQDesc(OP.QDesc)" title="{{OP.QDesc}}" style="cursor: pointer;text-align: center;">
                    <i class="material-icons upload-container__icon" (click)="openPopup(OP.Id, OP.QDesc)">message</i>
                   </td> -->
                   <td [class.cell-to-update]="highlightQDesc(OP.QDesc)" title="{{OP.QDesc}}" style="cursor: pointer; text-align: center;">
                    <div class="upload-container" (click)="openPopup(OP.Id, OP.QDesc)">
                      <i class="material-icons upload-container__icon"
                      [ngStyle]="{
                        color: OP.QDesc || OP.QuestionImagePath ? '#ed5565' : '#999',
                        border: OP.QDesc || OP.QuestionImagePath ? '1px solid #ed5565' : '1px solid transparent'
                       
                      }">
                        message
                      </i>
                    </div>
                  </td>
                  
                    <!-- Commented for TT-9514 -->
                  <!-- <td style="text-align: center;" >
                    <input hidden type='file' (change)="onSelectOPQuestionImage($event,OP.Id)"
                           #uploadImage>
                    <div class="input-container">
                      <div style="cursor: pointer;">
                        <i (click)="uploadImage.click()" *ngIf="!OP.QuestionImage"
                           class="material-icons">note_add</i>
                        <img (click)="EdiEqImage(OP.QuestionImage)" style="width:50px; height:50px"
                             *ngIf="OP.QuestionImage" [src]="sanitize(OP.QuestionImage)">
  
                        <mat-icon *ngIf="OP.QuestionImage"
                                  style="margin-left: -7px;cursor: pointer;"
                                  (click)="deleteQuestionimage(OP.Id,OP.IsNewImage)">
                          delete
                        </mat-icon>
                      </div>
                    </div>
                  </td> -->
                  <!-- <td class="inspection-component-photo" style="text-align: center;"> -->
                    <!-- Hidden input to upload image -->
                    <!-- <input hidden type="file" (change)="onSelectOPQuestionImage($event, OP.Id)" #uploadImage> -->
                  
                    <!-- Show icon if no image is uploaded -->
                    <!-- <div *ngIf="!OP.QuestionImage" style="cursor: pointer;">
                      <i class="material-icons upload-container__icon"
                         [ngStyle]="{
                           border: '1px solid #ccc',
                           color: '#999',
                           padding: '8px'
                         }"
                         (click)="uploadImage.click()">
                        add_a_photo
                      </i>
                    </div> -->
                    <!-- Show image and delete option if image is uploaded -->
                    <!-- <div *ngIf="OP.QuestionImage" style="display: flex; align-items: center; justify-content: center;">
                      <img (click)="EdiEqImage(OP.QuestionImage)"
                           [src]="sanitize(OP.QuestionImage)"
                           style="width: 50px; height: 50px; margin-right: 5px; cursor: pointer;" />
                  
                      <mat-icon
                        (click)="deleteQuestionimage(OP.Id, OP.IsNewImage)"
                        style="cursor: pointer; color: red;">
                        delete
                      </mat-icon>
                    </div>
                  </td> -->
                  
                  <!-- <td>
                      <div style="margin-left: 30px">
                          {{getMakeById(OP.ComponentMake)}}
                      </div>
                  </td> -->
                  <!-- <td>
                      <div style="margin-left: 30px">
                          {{OP.ComponentPartNo}}
                      </div>
                  </td> -->
                  <td>
                    <mat-checkbox color="primary" style="margin-left: 17px;" [checked]="OP.IsAnswer" [value]="OP.Id" (change)="onObsIsAnswerChange(OP.Id)"></mat-checkbox>
  
                  </td>
                  <td>
                    <mat-checkbox color="primary" style="margin-left: 17px;" [checked]="OP.IsImage" [value]="OP.Id" (change)="onObsIsImageChange(OP.Id)"></mat-checkbox>
                  </td>
  
                  <!-- new code TT-5655 -->
                  <!-- <td [class.cell-to-update]="highlightType(OP.InspectionType)">
                      <select id="OPInspectionType" placeholder="Inspection Type"
                          [(ngModel)]="OP.InspectionType" ngDefaultControl required
                          class="length-input"
                          style="height: 40px;
                      display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
  
                          required>
                          <option [value]="opt.ID" *ngFor="let opt of InspectionTypeList">
                              {{opt.Name}}
                          </option>
                      </select>
                  </td>  -->
  
                  <td>
  
                    <mat-form-field style="width: 110px">
                      <mat-select id="OPInspectionType" class="length-input3"
                                  style="min-width: 110px; height: 40px;
                      display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                  placeholder="Select Inspection Type"
                                  [(ngModel)]="OP.InspectionTypeID" ngDefaultControl>
                        <mat-option *ngFor="let opt of InspectionTypeList" [value]="opt.ID">
                          {{opt.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                  </td>
  
  
                  <td>
                    <div style="margin-left: 10px">
                      <ui-switch [(ngModel)]="OP.Active"></ui-switch>
  
                    </div>
                  </td>
  
  
                  <td>
                    <div style="margin-left: 30px">
                      <i style="color:red;cursor: pointer;" class="material-icons"
                         (click)="deleteOP(OP)">delete_outline</i>
  
                    </div>
                  </td>
                  <!-- show edit icon -->
                  <ng-container>
                    <td>
                      <div style="margin-left: 10px; cursor: pointer;">
                        <i class="material-icons"
                           (click)="EditObservatinPOint(OP.Id, 2)">edit</i>
  
                      </div>
                    </td>
                  </ng-container>
  
                  <!--   empty td -->
                  <!-- <ng-container *ngIf="OP.InspectionDate!='Never'">
                      <td>
                          <div style="margin-left: 30px">
                          </div>
                      </td>
                  </ng-container> -->
                  <!-- new code TT:5528 -->
                  <td style="display: flex;">
                    <div style="width: 30px; padding-top: 15px;">
                      <span title="Move up"
                            class="input-icon image-icon-padding sort-component-icon"
                            style="margin-right: 10px!important"
                            *ngIf="isFirstComponentInList(OP.Id, OP.ComponentTypeId)"
                            (click)="recalculateSortOrder(OP.Id, false)">
                        <i class="material-icons">arrow_upward</i>
                      </span>
                    </div>
                    <div style="width: 30px; padding-top: 16px;">
                      <span title="Move down"
                            class="input-icon image-icon-padding sort-component-icon"
                            style="margin-right: 10px!important"
                            *ngIf="isLastComponentInList(OP.Id, OP.ComponentTypeId)"
                            (click)="recalculateSortOrder(OP.Id, true)">
                        <i class="material-icons">arrow_downward</i>
                      </span>
                    </div>
                  </td>
                </tr>
  
  
              </ng-container>
            </tbody>
          </table>
        </div>
        <br />
        <!--<div *ngIf="isvalidStep3">
          <mat-checkbox *ngIf="HasChildImplements" [checked]="false" color="primary"
                        [(ngModel)]="cbApplyToAll" (change)="checkValueAll(cbApplyToAll)">
            Apply to all
            Implements
          </mat-checkbox>
          <mat-checkbox [checked]="false" color="primary" [(ngModel)]="cbApplyToOne"
                        (change)="checkValueOne(cbApplyToOne)">Apply to this Implement</mat-checkbox>
        </div>-->
        <br />
        <div class="button-container">
          <button mat-raised-button (click)="GoBackToCompScreen()">Back</button>
          <button mat-raised-button color="warn" (click)="goToStep(3)"
                  [disabled]="!stepThreeIsValid()">
            Next
          </button>
        </div>
      </div>
  
    </div>
  </div>
  <!-- Modal Popup -->
<div *ngIf="showPopup" class="modal-overlay" (click)="closePopup()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="ttmodal__header">
      <span class="ttmodal__title">Question Instruction & Image</span>
      <i class="material-icons ttmodal__close-button" (click)="closePopup()">close</i>
    </div>
    <div class="upload-container" style="margin-top: 15px; text-align: center; padding: 20px; min-height: 150px;">
      <input hidden type="file" (change)="onSelectModalImage($event)" #modalImageInput accept="image/*">
      <div *ngIf="!selectedQImage">
        <i class="material-icons upload-container__icon">add_a_photo</i>
      </div>
      <div *ngIf="selectedQImage" style="display: flex; align-items: center; justify-content: center;">
        <img [src]="selectedQImage" style="width: 60%; height: 60%; margin-right: 5px; cursor: pointer;" />
      </div>
    </div>
    <div style="display: flex; justify-content: end; gap: 10px; margin: 10px 0;">
      <button mat-raised-button class="button button-delete" [disabled]="!selectedQImage" (click)="deleteQuestionimage(selectedId, isNewSelectedQImage)"><i class="material-icons button__icon">delete</i><span>{{'Delete Image' | translate | async}}</span></button>
      <button mat-raised-button color="warn" (click)="modalImageInput.click()"><i class="material-icons button__icon" style="padding-right: 8px;">cloud_upload</i><span>{{'Upload Image' | translate | async}}</span></button>
    </div>
    <textarea [(ngModel)]="selectedQDesc" rows="7" cols="70" placeholder="Question Instructions"></textarea>
    <div style="display: flex; justify-content: end; gap: 10px; margin: 10px 0;">
      <button mat-raised-button class="button button-delete" [disabled]="!selectedQDesc" (click)="deleteQuestionInstruction(selectedId)" ><i class="material-icons button__icon">delete</i><span>{{'Delete Comment' | translate | async}}</span></button>
      <button mat-raised-button color="warn" class="save-btn"  (click)="saveUpdate()"><i class="material-icons save-button__icon" style="padding-right: 8px;">save</i><span>{{'Save/Update' | translate | async}}</span></button>
    </div>
  </div>
</div>

<schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
                       [(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
                       [(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement" (mouseoverMP)="onMouseOverMP($event)"
                       (mouseoverOP)="onMouseOverOP($event)" (mousedown)="onMouseButton_Schematic($event)" (mouseup)="onMouseButton_Schematic($event)"
                       (mousemove)="onMouseMove_Schematic($event)"
                       [schematic]="selectedSchematic"
                       (closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)"
                       [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate" ></schemantic-op-popup>
